<nav class="sidebar">
  <div class="sidebar__menu">
    @for (item of menuItems; track item.label) { @if (item.children && item.children.length > 0) {
    <!-- Parent menu item with dropdown -->
    <div class="sidebar__menu-item">
      <div
        class="sidebar__menu-parent"
        (click)="toggleMenu(item.label)"
        (keydown.enter)="toggleMenu(item.label)"
        (keydown.space)="toggleMenu(item.label)"
        tabindex="0">
        <div class="sidebar__menu-parent-content">
          @if (item.icon) {
          <ng-glyph class="sidebar__menu-icon" [name]="item.icon"></ng-glyph>
          }
          <span class="sidebar__menu-text">{{ item.label }}</span>
        </div>
        <ng-glyph class="sidebar__dropdown-icon" [name]="isMenuExpanded(item.label) ? 'expand_less' : 'expand_more'"></ng-glyph>
      </div>

      <!-- Child menu items -->
      @if (isMenuExpanded(item.label)) {
      <div class="sidebar__submenu">
        @for (child of item.children; track child.label) {
        <a [routerLink]="child.route" routerLinkActive="sidebar__menu-link--active" class="sidebar__menu-link sidebar__submenu-link">
          @if (child.icon) {
          <ng-glyph class="sidebar__menu-icon" [name]="child.icon"></ng-glyph>
          }
          <span class="sidebar__menu-text">{{ child.label }}</span>
        </a>
        }
      </div>
      }
    </div>
    } @else {
    <!-- Regular menu item without children -->
    <div class="sidebar__menu-item">
      <a [routerLink]="item.route" routerLinkActive="sidebar__menu-link--active" class="sidebar__menu-link">
        @if (item.icon) {
        <ng-glyph class="sidebar__menu-icon" [name]="item.icon"></ng-glyph>
        }
        <span class="sidebar__menu-text">{{ item.label }}</span>
      </a>
    </div>
    } }
  </div>
</nav>
